export default __webpack_public_path__ + "static/media/004-Bulldog.47cffbac.svg";